import { lazy } from 'react'

export const AnalyzingAnswersV1 = lazy(() => import('./v1/AnalyzingAnswersV1'))
export const AnalyzingAnswersV2 = lazy(() => import('./v2/AnalyzingAnswersV2'))
